export default {
  // Hero
  'hero.badge': '关于 GBCOSPACK',
  'hero.title': '重新定义化妆品包装采购',
  'hero.subtitle':
    '我们是连接化妆品品牌与已认证制造联盟的全球 B2B 门户，让采购变得透明、高效且可靠。',

  // Story
  'story.label': '我们的故事',
  'story.title': '为连接品牌与工厂而生',
  'story.p1':
    'GBCOSPACK 的创立，是为了解决化妆品行业的一个真实痛点：从海外工厂采购包装充满不透明、零散与风险。品牌方难以核实供应商、比较价格，或预判某种后加工效果的实际观感。',
  'story.p2':
    '我们组建了一个由大型、高度自动化工厂构成的制造联盟，并将它们的产品数据标准化到一个可搜索的平台。现在，你只需在一个地方，就能浏览、比较、通过 AI 预览后加工效果，并申请透明的报价。',
  'story.p3':
    '如今，我们服务超过 50 个国家的化妆品品牌、OEM/ODM 公司与经销商——帮助他们更快、更低风险地推出产品。',

  // Mission
  'mission.label': '我们为何存在',
  'mission.title': '我们的使命与愿景',
  'mission.subtitle': '三条原则指引我们所做的一切，以及我们引入的每一位合作伙伴。',
  'mission.m1.title': '我们的使命',
  'mission.m1.desc':
    '通过将品牌与已认证的制造联盟直接连接，让化妆品包装采购变得透明、高效且可靠。',
  'mission.m2.title': '我们的愿景',
  'mission.m2.desc':
    '成为全球最值得信赖的化妆品包装目的地——让每一个品牌都能满怀信心地采购。',
  'mission.m3.title': '我们的承诺',
  'mission.m3.desc':
    '每一家供应商都经过审核，每一个价格都公开透明，每一笔订单都有从样品到出货的多阶段质量管控作为保障。',

  // Values
  'values.label': '我们的核心价值观',
  'values.title': '我们所坚持的',
  'values.subtitle': '这些价值观塑造了我们审核供应商、制定价格以及服务每一位客户的方式。',
  'values.v1.title': '透明',
  'values.v1.desc': '没有隐藏费用。完整的成本明细与标准化的规格表，让比较一目了然。',
  'values.v2.title': '品质优先',
  'values.v2.desc': '工厂与出货前的多阶段质检，每一批次全程可追溯。',
  'values.v3.title': '可靠',
  'values.v3.desc': '稳定、自动化的量产，一单一单，始终如一。',
  'values.v4.title': '创新',
  'values.v4.desc': 'AI 后加工预览与以图搜图，让探索比以往更快。',
  'values.v5.title': '全球伙伴关系',
  'values.v5.desc': '门到门物流，以及覆盖 50 多个国家品牌的本地化支持。',
  'values.v6.title': '可持续性',
  'values.v6.desc': '环保包装方案与负责任的采购，打造更绿色的供应链。',

  // Stats
  'stats.label': '用数字说话',
  'stats.title': '规模化信赖',
  'stats.subtitle': '数十年制造与全球贸易沉淀出的业绩记录。',
  'stats.s1.value': '20+',
  'stats.s1.label': '年制造经验',
  'stats.s2.value': '1,000+',
  'stats.s2.label': '已认证供应商',
  'stats.s3.value': '50,000+',
  'stats.s3.label': '产品 SKU',
  'stats.s4.value': '50+',
  'stats.s4.label': '服务国家',

  // Milestones
  'milestones.label': '我们的历程',
  'milestones.title': '塑造我们的里程碑',
  'milestones.subtitle': '从一家工厂，到全球制造联盟。',
  'milestones.m1.title': '首家工厂成立',
  'milestones.m1.desc': 'CosmePack Manufacturing Group 开启一体化化妆品包装生产。',
  'milestones.m2.title': '玻璃容器专业化',
  'milestones.m2.desc': 'Cristallo Glassworks 推出高透明玻璃容器生产线。',
  'milestones.m3.title': '软管与塑料扩张',
  'milestones.m3.desc': 'FlexoTech 与 PolyForm 加入，为联盟带来复合软管与 PET/PP 瓶。',
  'milestones.m4.title': '全球门户上线',
  'milestones.m4.desc': 'GBCOSPACK 作为面向全球品牌的统一 B2B 采购平台正式开放。',
  'milestones.m5.title': 'AI 预览与以图搜图',
  'milestones.m5.desc': 'AI 后加工预览与相似图片搜索，让探索即时化。',
  'milestones.m6.title': '服务 50 多个国家',
  'milestones.m6.desc': '联盟如今为五大洲的品牌供应化妆品包装。',

  // CTA
  'cta.label': '与我们合作',
  'cta.title': '让我们一起打造你的下一款产品',
  'cta.subtitle': '无论你需要现货容器还是完全定制的设计，我们的团队都随时为你提供指导。',
  'cta.quote': '申请报价',
  'cta.contact': '联系我们的团队',
  'cta.browse': '浏览产品',
};